import { z } from 'zod'
import { decodedUnboundedValueSchema } from './decodedUnboundedValueSchema'

/** Zod v4 codec for a `number | '<literal>'` wire field: decodes the literal to `Infinity`, encodes it back, and `bounds.min` rejects 0 and non-integers on encode. */
export const unboundedValueCodec = (literal: string, bounds?: { readonly min: number }) =>
  z.codec(
    z.union([z.int(), z.enum([literal])]),
    bounds === undefined
      ? decodedUnboundedValueSchema
      : decodedUnboundedValueSchema.refine(
          (value) => value === Infinity || (Number.isInteger(value) && value >= bounds.min),
          { message: 'out_of_range' }
        ),
    {
      decode: (wire) => (typeof wire === 'string' ? Infinity : wire),
      encode: (domain) => (Number.isFinite(domain) ? domain : literal)
    }
  )
